import { render, staticRenderFns } from "./image.vue?vue&type=template&id=1af74a3b&scoped=true&"
import script from "./image.vue?vue&type=script&lang=js&"
export * from "./image.vue?vue&type=script&lang=js&"
import style0 from "./image.vue?vue&type=style&index=0&id=1af74a3b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af74a3b",
  null
  
)

export default component.exports